export default __webpack_public_path__ + "static/media/Help_pls_user.d4d1c1eb.pdf";